import React from "react";
import { Box, Container, Grid, Typography, Button, Paper } from "@mui/material";
import WebIcon from "@mui/icons-material/Web";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SearchIcon from "@mui/icons-material/Search";
import VerifiedIcon from "@mui/icons-material/Verified";

const benefits = [
  {
    icon: <WebIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Personalización Total",
    description:
      "Tu página web completamente adaptada a tu marca, reflejando la identidad de tu alojamiento.",
    bgColor: "#565254",
  },
  {
    icon: <PhoneIphoneIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Optimización Móvil",
    description:
      "Diseño responsive para garantizar una excelente experiencia en dispositivos móviles.",
    bgColor: "#565254",
  },
  {
    icon: <SearchIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Posicionamiento en Google",
    description:
      "Sitios web optimizados para SEO, logrando mayor visibilidad y más reservas.",
    bgColor: "#565254",
  },
  {
    icon: <VerifiedIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Reservas Directas",
    description:
      "Conectado con nuestro Motor de Reservas, facilitando la conversión de visitas en reservas.",
    bgColor: "#565254",
  },
];

function HeroWebsiteBuilder() {
  return (
    <Box
      sx={{
        scrollSnapAlign: "start",
        background: "linear-gradient(0deg, #d2c2f2, #903AF2)",

        height: "100vh",
        color: "white",
        py: 8,
        px: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Información principal */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              sx={{
                fontFamily: "'Red Hat Display', sans-serif",
                color: "#ffffff",
              }}
            >
              Website Builder de Ubika
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                fontFamily: "'Merriweather Sans', sans-serif",
                color: "#ECECEC",
              }}
            >
              Destacá tu alojamiento con un sitio web personalizado, moderno y
              fácil de usar. Con Ubika, obtenés un sitio completamente adaptado
              a tu marca, optimizado para celulares, con imágenes de las
              instalaciones, información clara y entrada de reservas directas.
              Conectado con nuestro motor de reservas y preparado para
              posicionarse en Google.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#EE964B",
                color: "#ffffff",
                fontWeight: "bold",
                fontFamily: "'Red Hat Display', sans-serif",
                px: 4,
                py: 1.5,
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#d97e3e",
                },
              }}
            >
              Ver Demo
            </Button>
          </Grid>

          {/* Beneficios principales */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: "12px",
                      backgroundColor: benefit.bgColor,
                      color: "#ffffff",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                      }}
                    >
                      {benefit.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mt: 1, textAlign: "center" }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ textAlign: "center", fontSize: "0.95rem" }}
                    >
                      {benefit.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HeroWebsiteBuilder;
